import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
  ) { 

  }
  newContract(token, contract): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getNewContractURL, contract, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getContracts(token): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetContractsURL, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getContract(token, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetContractURL(contractId), httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  updateContract(token, contract, contractId): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.put<any>(this.globalService.getUpdateContractURL(contractId), contract, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  deleteContract(token, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.getDeleteContractURL(contractId), httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  assocContractToCustomers(token, customers, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getGetAssocContractToCustomerURL(contractId), customers, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getAssocCustomersToContract(token, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getGetAssocedCustomerToContractURL(contractId), httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }
}
